import { ActionBase } from '../../../core/store/action/ActionBase';
import { DynamicDataSetModel } from '../../models/DynamicDataSetModel';

export const CREATEDRAFT_DYNAMICDATASET_SUCCESS = '[DynamicDataSet] Creat Draft Success';

export class CreateDraftDynamicDataSetSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = CREATEDRAFT_DYNAMICDATASET_SUCCESS;

  constructor(public payload: { dynamicDataSet: DynamicDataSetModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/store/actions/CreateDraftDynamicSuccessAction.ts